<template>
  <!-- <div class="container" @touchstart="touchstartFunction" @touchmove="touchmoveFunction"> -->
    <!-- <better-scroll  :scrollY="true" class="container"> -->
      <div class="container">
        <div class="wrapper">
            <div class="title" :class="{'title_active':isGetMore}">
                <div class="status">
                  <div class="left">
                    <span>投诉状态</span>
                    <span class="item" v-show="oversee">督办件</span>
                    <span class="item" v-show="overTime">超时</span>
                    <span class="item" v-show="vturn">诉转案</span>
                  </div>
                  <div class="right">处理总时长</div>
                </div>
                <div class="abount_time">
                  <span>{{formData.statueValue}}</span>
                  <span>{{formData.handleLong|filt4}}</span>
                </div>
                <div class="step1" v-if="dataList.batch===2&&dataList.schedule!=9&&dataList.schedule!=10">
                          <div class="item_step" v-for="(item,index) in statusList" :key="index">
                            <span class="col" :class="{'col_active':index<=currentIndex}"></span>
                            <p :class="{'line':index<currentIndex}"></p>
                            <p :class="{'line1':index==currentIndex}"></p>
                            <span class="step_text" :class="{'step_active':index<=currentIndex}">{{item.text}}</span>
                          </div>
                          <div class="item_next">
                            <span class="col" :class="{'col_active':currentIndex==7}"></span>
                            <span class="step_text" :class="{'step_active':currentIndex==7}">评价</span>
                          </div>
                          <div class="s_box" v-if="dataList.schedule==6">
                              <div class="info">
                                  <div class="jiao"></div>
                                  <div class="step_content1" v-for="(item, index) in dataList.details" :key="index" @click="callPhone(item)">
                                      <div class="left">
                                          <img src="../../../../assets/image/icon_peple.png" alt="">
                                          <span>{{item.value}}</span>
                                      </div>
                                      <div class="right">{{item.statue}}</div>
                                  </div>
                              </div>
                          </div>
                </div>
                <div class="step" v-if="dataList.batch===1&&dataList.schedule!=9&&dataList.schedule!=10">
                  <div class="step_container">
                    <div class="item_step" v-for="(item,index) in stepList" :key="index">
                      <span class="col" :class="{'col_active':index<=currentIndex}"></span>
                      <p :class="{'line':index<currentIndex}"></p>
                      <p :class="{'line1':index==currentIndex}"></p>
                      <span class="step_text" :class="{'step_active':index<=currentIndex}">{{item.text}}</span>
                    </div>
                    <div class="item_next">
                      <span class="col" :class="{'col_active':dataList.schedule==8}"></span>
                      <span class="step_text" :class="{'step_active':dataList.schedule==8}">评价</span>
                    </div>
                  </div>
                </div>
                <div class="tip_info" v-if="dataList.batch===1&&dataList.schedule!=9&&dataList.schedule!=10&&dataList.schedule==3">
                  <div class="info" :class="{'info_active':currentIndex===3,'info_active1':currentIndex===4}">
                    <div
                      class="jiao"
                      :class="{'jiao_active1':currentIndex===1,'jiao_active2':currentIndex===2,'jiao_active3':currentIndex===3||currentIndex===4}"
                    ></div>
                    <div v-for="(item,index) in dataList.details" :key="index" class="tip_info_item">
                      <div class="tip_info_item_li" @click="callPhone(item)">
                        <div class="tip_info_item_people">
                          <img src="../../../../assets/image/icon_peple.png" alt />
                        </div>
                        <div class="tip_info_item_left">{{item.value}}</div>
                        <div class="tip_info_item_right">{{item.statue}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <ul class="title_foot">
                  <li>
                    <div class="title_foot_li_left">第一落点属地：{{formData.incidentBefallCityName}}</div>
                    <div class="title_foot_li_right">响应时长：{{formData.acceptLong|filt3}}</div>
                  </li>
                  <li>
                    <div class="title_foot_li_left">第一落点地：{{formData.firstPointValue}}</div>
                    <div class="title_foot_li_right">处理总时长：{{formData.handleLong|filt4}}</div>
                  </li>
                  <li>
                    <div class="title_foot_li_left">第一落点名称：{{formData.firstPointName}}</div>
                  </li>
                </ul>
                <div class="pull" @click="getMore">
                  <img src="../../../../assets/complaint/pull.png" :class="{'img_active':isGetMore}" />
                </div>
            </div>
            <div class="content" >
              <div class="return_content" v-if="detailInfo.is_return_visit==1" >
                  <div class="item_box2">
                        <p class="tip1">回访评价:</p>
                        <p class="tip2" v-if="getKey.statue==10" style="color:#36B374;">{{getKey.return_visit_score|filt5}}</p>
                        <p v-if="getKey.statue==1">{{getKey.statue_value}}</p>
                        <p v-if="getKey.statue==20">{{getKey.statue_value}}</p>
                  </div>
                  <div class="item_box2">
                        <p class="tip1">回访时间:</p>
                        <p>{{getKey.return_visit_time}}</p>

                  </div>
                  <div class="item_box2">
                        <p class="tip1">生成时间:</p>
                        <p >{{getKey.create_time}}</p>
                  </div>
                  <div class="returnDetail" v-if="!fromType" @click="goReturnDetail">
                        <p>详情</p>
                        <img src="../../../../assets/image/right.png"/>
                  </div>
              </div>
              <better-scroll class="nav" :scrollX="true">
                <div class="wrapper">
                  <router-link
                    :to="item.path"
                    class="item"
                    :key="index"
                    tag="span"
                    replace
                    v-for="(item,index) in navList"
                    exact-active-class="active">
                      {{item.type}}
                  </router-link>
                </div>
              </better-scroll>
            </div>
        <router-view :class="{'activeClass':showBtn,'view':!showBtn}" ref="boxParent"></router-view>
        </div>
        <tipTimeLineAssess :showBox1="showBox1" @setHideBox="setHideBox" :timeList="timeList"></tipTimeLineAssess>
        <callPhone :combinPhone="combinPhone" ref="callPhone1"></callPhone>
      </div>
  <!-- </better-scroll> -->
</template>
<script>
    import betterScroll from '../../../../components/base/betterScroll';
    import api from '../../../../service/modules/complaintApis';
    import util from '../../../../utils/common'
    import tipTimeLineAssess from './tipTimeLineAssess';
    import callPhone from '../../../../components/callPhone'
    export default {
        components: {
            tipTimeLineAssess,
            betterScroll,
            callPhone
        },
        data () {
            return {
                stepList: [
                    { text: '发起' },
                    { text: '响应' },
                    { text: '处理' },
                    { text: '反馈' }
                ],
                statusList: [
                    { text: '发起' },
                    { text: '响应' },
                    { text: '处理' },
                    { text: '反馈' },
                    { text: '申诉' },
                    { text: '二次处理' },
                    { text: '二次反馈' }
                ],
                getCheckList: this.$store.state.complaint.isCheckList,
                startY: '',
                timeList: '',
                showBox1: false, // 展示部门时间轴
                isShowStep: false,
                currentIndex: 1,
                isGetMore: false,
                showBtn: false,
                item: util.getJsonLocal('item'), 
                userInfo: this.$store.state.complaint.userInfo || util.getJsonLocal('userInfoComplaint'), // 用户信息
                oversee: false,
                overTime: false,
                vturn: false,
                dataList: '',
                showList: [], // 头部标签的集合
                imgSrc: '../../../../assets/image/xiala.png',
                detailInfo: '',
                showPop: false,
                popContent: '',
                combinPhone: 0,
                navList: [
                    {
                        type: '投诉单',
                        select: true,
                        path: '/complaint/detailListAssess/complaintSheetAssess'
                    },
                    {
                        type: '信息补充',
                        select: false,
                        path: '/complaint/detailListAssess/writeInfoAssess'
                    },
                    {
                        type: '通话记录',
                        select: false,
                        path: '/complaint/detailListAssess/phoneHistoryAssess'
                    },
                    {
                        type: '处置详情',
                        select: false,
                        path: '/complaint/detailListAssess/timeLineAssess'
                    }
                ],
                isShowFiling: false,
                sub_id: '',
                complain_number: '',
                main_complain_number: '',
                ishow: false,
                ishow1: false,
                isHandleWorkbench: this.$store.state.complaint.isHandleWorkbench || util.getJsonLocal('setWorkType'),
                basicDetailslist: '',
                isback: this.$store.state.complaint.isBackDetail || util.getJsonLocal('isBack'),
                fromType: this.$route.query.fromType,
                getKey: '',
            };
        },
        computed: {
            formData: {
                get () {
                    return this.$store.state.complaint.basicImformation;
                },
                set (val) {
                    this.$store.state.complaint.basicImformation = val;
                }
            }
        },
        watch: {
            formData (val) {
                this.detailInfo = val;
                if (val.isReturnVisit == 1) { // 是否有回访单
                    this.getReturnDetail();
                }
                this.showList = val.markList;
                for (let i = 0; i < this.showList.length; i++) {
                    if (this.showList[i].markCode === 4) {
                        this.overTime = true
                    }
                    if (this.showList[i].markCode === 3) {
                        this.vturn = true
                    }
                    if (this.showList[i].markCode === 2) {
                        this.oversee = true
                    }
                }
            }
        },
        created () {
            this.topList();

            // if (this.isHandleWorkbench === 'reportIng') { // 上报后的
            //     this.getSend();
            // }
            // if (this.isHandleWorkbench === 'centerAccepted' || this.isHandleWorkbench === 'centerHandle') { // 转办显示的机构
            //     this.getOriList();
            // }
            // if (this.isHandleWorkbench === 'splitOrderReportIng') { // 拆单后需要调用的接口
            //     this.getOriList1();
            // }
            // this.getInfo();
        },
        mounted () {
            this.$on('showTipe', (item) => {
                this.getLine(item);
            })
            this.$on('showCallPhone', (value) => {
                this.combinPhone = value;
                this.$refs.callPhone1.showBox();
            })
            if (this.getCheckList) {
                this.navList.splice(2, 1);
            }

        },
        methods: {
            callPhone (item) { // 跳转通讯录
                // this.$router.push(`/provincemaillist?code=${item.depId}&title=${encodeURI(item.value)}`)
                window.yyn.invokeJSB(
                    'openWindow', {
                        openUrl: `${this.globalApp.getSystemInfo().host}web/#/provincemaillist?code=${item.depId}&title=${encodeURI(item.value)}`,
                        isFullScreen: 0,
                        setTitle: item.value,
                        needLoading: 1
                    },
                    cb => {
                        console.log(cb, 'callback');
                    }
                );
            },
            async getReturnDetail () {
                const params = {
                    data:{
                      mainComplainNumber: this.item.mainComplainNumber,
                      complainNumber: this.item.complainNumber,
                      type: 'returnVisitDetails'
                    }
                    
                }
                const result = await api.worker.apomentInfo(params);
                if (result.errorcode === 0) {
                    this.getKey = result.data.returnVisitDetails;
                }
            },
            goReturnDetail () {//回访单详情
                this.$router.push({
                    path: '/complaint/returnDetail',
                    query: {
                        fromType: 'leaderDetail'
                    }
                })
            },
            getLine (item) {
                // 获取时间轴数据
                let parms = {
                    data:{
                      mainComplainNumber: this.item.mainComplainNumber,
                      type: 'timeAxis',
                      complainNumber: this.item.complainNumber,
                      timeAxisType: 'dep'
                    }
                    
                };
                api.worker.apomentInfo(parms).then(res => {
                    if (res.ret === 0) {
                        this.showBox1 = true;
                        this.timeList = res.data.timeAxis;
                    }
                });
            },
            // // 控制部门时间轴的显示隐藏
            setHideBox () {
                this.showBox1 = false;
            },
            goTravel () {
                this.$router.push({
                    path: '/complaint/travelListQuery'
                })
            },
            getMore () {
                // 头部展开部分
                this.isGetMore = !this.isGetMore;
            },
            topList () {// 获取头部数据
                let parms = {
                    data:{
                      mainComplainNumber: this.item.mainComplainNumber,
                      type: 'scheduleDetails'
                    }
                };
                api.worker.apomentInfo(parms).then(res => {
                    if (res.ret === 0) {
                        this.dataList = res.data.scheduleDetails;
                        this.currentIndex = parseInt(this.dataList.schedule) - 1;
                    }
                });
            },
            // getSend () { // 上报完了，详情多出的上报机构
            //     let parms = {
            //         data:{
            //           main_complain_number: this.item.main_complain_number,
            //           id: this.item.id,
            //           type: 'reportDetails'
            //         }
            //     };
            //     api.detailsInfo(parms).then(res => {
            //         console.log(res);
            //         if (res.ret === 0) {
            //             this.$broadcast('statusInfo', res.data);
            //         }
            //     });
            // },
            // getOriList () { // 转办后需要显示的的转办机构
            //     let parms = {
            //         data:{
            //           main_complain_number: this.item.main_complain_number,
            //           id: this.item.id,
            //           type: 'transformationDetails'
            //         }
            //     };
            //     api.woker.detailsInfo(parms).then(res => {
            //         if (res.ret === 0) {
            //             this.$broadcast('getOriList', res.data);
            //         }
            //     });
            // },
            // getOriList1 () { // 拆单后需要显示的信息
            //     let parms = {
            //         data:{
            //           main_complain_number: this.item.main_complain_number,
            //           id: this.item.id,
            //           type: 'splitDetails'
            //         } 
            //     };
            //     api.detailsInfo(parms).then(res => {
            //         console.log(res);
            //         if (res.ret === 0) {
            //             this.$broadcast('sendSplitInfo', res.data);
            //         }
            //     });
            // }
        },
        filters: {
            filt3 (str) {
                let duration = str;

                let zero = function (times) {
                    return times;
                };
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.floor((duration / 60) % 60));
                let seconds = zero(Math.floor((duration % 60)));
                let times = '';
                if (hour > 0) {
                    times += hour + '时';
                }
                times += minutes + '分';
                times += seconds + '秒'
                return times;
            },
            // 计算时限
            filt4 (str) {
                let duration = str;
                let zero = function (times) {
                    return times < 10 ? '0' + times : times;
                }
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.floor((duration / 60 % 60)));
                let seconds = zero(Math.floor((duration % 60)));
                let times = ''
                if (hour > 0) {
                    times += hour + ':'
                } else {
                    times += '00' + ':'
                }
                times += minutes + ':'
                times += seconds

                return times
            },
            filt5 (value) {
                if (value == 3) {
                    return '满意'
                } else if (value == 2) {
                    return '基本满意'
                } else if (value == 1) {
                    return '不满意'
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  .wrapper{
    width:100%;
  .title {
    width: 100%;
    height: 105px;
    background-color: @base-color;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
    left: 0;
    top: 0;
    transition: all 0.5s ease-in-out;
    overflow: hidden;
    .status {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 15px;
      .left {
        display: flex;
        align-items: center;
        span:nth-child(1) {
          font-size: 15px;
          color: #fff;
          opacity: 0.5;
        }
        span:nth-child(2) {
          margin-left: 10px;
        }
        span:nth-child(3) {
          background: #ff4d4d;
          margin-left: 10px;;
        }
        span:nth-child(4) {
          background: #ff8c19;
          margin-left: 10px;;
        }
        .item {
          display: inline-block;
          width: 44px;
          height: 19px;
          text-align: center;
          line-height: 21px;
          font-size: 11px;
          background-color: #2283e6;
          border-radius: 17px;
          color: #fff;
        }
      }
      .right {
        font-size: 14px;
        color: #fff;
        opacity: 0.5;
      }
    }
    .abount_time {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      span {
        font-size: 14px;
        color: #fff;
      }
    }
    .step {
      width: 100%;
      padding-left: 14px;
      // display: flex;
      // flex-direction: row;
      // align-items: center;
      margin-top: 46px;
      .step_container {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        .item_step {
          width: 24%;
          height: 24px;
          position: relative;
          border-top: 1px solid #53C88D;
          .col {
            position: absolute;
            left: -5px;
            top: -6px;
            width: 10px;
            height: 10px;
            background-color: #53C88D;
            border-radius: 50%;
          }
          .col_active {
            background-color: #fff;
          }
          .step_text {
            position: absolute;
            left: -10px;
            bottom: -5px;
            color: rgba(255, 255, 255, 0.5);
            font-size: 13px;
          }
          .step_active {
            color: #fff;
          }
          .line {
            position: absolute;
            width: 100%;
            height: 1px;
            background-color: #fff;
            left: 2px;
            top: -1px;
          }
          .line1 {
            position: absolute;
            width: 50%;
            height: 1px;
            background-color: #fff;
            left: 2px;
            top: -1px;
          }
        }
      }
      .item_next {
        width: 6%;
        height: 24px;
        position: relative;
        .col {
          position: absolute;
          left: -5px;
          top: -4px;
          width: 10px;
          height: 10px;
          background-color: #53C88D;
          border-radius: 50%;
        }
        .col_active {
          background-color: #fff;
        }
        .step_text {
          position: absolute;
          left: -10px;
          bottom: -5px;
          color: rgba(255, 255, 255, 0.5);
          font-size: 13px;
        }
        .step_active {
          color: #fff;
        }
      }
    }
    .tip_info {
      width: 100%;
      margin-top: 20px;
      opacity: 0.7;
      // position: relative;
      .info {
        width: 218px;
        // overflow: hidden;
        background: #2E9963;
        position: relative;
        left: 0;
        .jiao {
          position: absolute;
          left: 0px;
          top: -23px;
          width: 14px;
          height: 14px;
          border-top: 14px solid transparent;
          border-right: 14px solid transparent;
          border-bottom: 14px solid #2E9963;
          border-left: 14px solid transparent;
        }
        .jiao_active1 {
          left: 80px !important;
        }
        .jiao_active2 {
          left: 160px !important;
        }
        .jiao_active3 {
          left: 185px !important;
        }
      }
      .info_active {
        left: 54px !important;
      }
      .info_active1 {
        left: 136px !important;
      }
      .tip_info_item {
        padding-top: 6px;
        .tip_info_item_li {
          overflow: hidden;
        }
        width: 100%;
        line-height: 24px;
        font-size: 12px;
        color: #ffffff;
        .tip_info_item_people {
          float: left;
          margin: 5px 6px 0 16px;
          width: 12px;
          height: 13px;
        }
        .tip_info_item_left {
          float: left;
          overflow: hidden;
          width: 100px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .tip_info_item_right {
          float: right;
          margin-right: 8px;
        }
      }
    }

    .step1::-webkit-scrollbar{
      width: 0;
      height: 0;
      color: transparent;
    }
    .step1{
      width:100%;
      padding-top: 46px;
      white-space: nowrap;
      overflow-x:scroll;
       overflow-y: hidden;
      padding-left:10px;
      padding-bottom: 10px;
        .item_step {
          width: 80px;
          height: 24px;
          display: inline-block;
          position: relative;
          border-top: 1px solid #53C88D;
          .col {
            position: absolute;
            left: -5px;
            top: -6px;
            width: 10px;
            height: 10px;
            background-color: #53C88D;
            border-radius: 50%;
          }
          .col_active {
            background-color: #fff;
          }
          .step_text {
            position: absolute;
            left: -10px;
            bottom: -5px;
            color: rgba(255, 255, 255, 0.5);
            font-size: 13px;
          }
          .step_active {
            color: #fff;
          }
          .line {
            position: absolute;
            width: 100%;
            height: 1px;
            background-color: #fff;
            left: 2px;
            top: -2px;
          }
          .line1 {
            position: absolute;
            width: 50%;
            height: 1px;
            background-color: #fff;
            left: 2px;
            top: -2px;
          }

        }
        .item_next {
          width: 6%;
          height: 24px;
          display: inline-block;
          position: relative;
          .col {
            position: absolute;
            left: -5px;
            top: -4px;
            width: 10px;
            height: 10px;
            background-color: #53C88D;
            border-radius: 50%;
          }
          .col_active {
            background-color: #fff;
          }
          .step_text {
            position: absolute;
            left: -10px;
            bottom: -5px;
            color: rgba(255, 255, 255, 0.5);
            font-size: 13px;
          }
          .step_active {
            color: #fff;
          }
        }
        .s_box{
            position: relative;
            top:10px;
            width: 218px;
            right: -356px;
            // right:-197px;
            padding-right: 30px;
            background: rgba(46, 153, 99, 0.6);
            .jiao {
                  position: absolute;
                  left: 33px;
                  top: -20px;
                  width: 14px;
                  height: 14px;
                  border-top: 10px solid transparent;
                  border-right: 10px solid transparent;
                  border-bottom: 10px solid rgba(46, 153, 99, 0.6);
                  border-left: 10px solid transparent;
              }
              .info {
                  margin-top: 10px;
                  width: 218px;
                  padding: 6px 16px;
                  .step_content1 {
                      display: flex;
                      justify-content: space-between;
                      padding: 6px 5px 6px 0px;
                      color: #2E9963;
                      .left {
                        img {
                          display: inline-block;
                          float: left;
                          width: 13px;
                          height: 14px;
                        }
                        span {
                          display: inline-block;
                          float: right;
                          max-width: 100px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          margin-top: 2px;
                          margin-left: 5px;
                          opacity: 0.8;
                          color: #fff;
                          width: 100px;
                        }
                      }
                      .right {
                        margin-top: 2px;
                        color: #fff;
                        opacity: 0.8;
                      }
                  }
              }
        }

    }
    .pull {
      height: 41px;
      position: absolute;
      left: 0;
      right: 0;
      // left: 50%;
      // margin-left: -20px;
      bottom: 0;
      text-align: center;
      background-color: @base-color;
      img {
        width: 17px;
        height: 9px;
        display: inline-block;
        margin-top: 16px;
        position: relative;
        transition: all 0.5s ease-in-out;
      }
      .img_active {
        transform: rotate(180deg) !important;
      }
    }
    .title_foot {
      overflow: hidden;
      margin-top: 24px;
      opacity: 0.7;
      padding-bottom: 46px;
      li {
        line-height: 28px;
        color: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title_foot_li_left {
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 56%;
          overflow: hidden;
        }
        .title_foot_li_right {
          width: 42%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
  .title_active {
    height: 100% !important;
  }
  .content {
    width: 100%;
    padding: 10px 14px 12px 14px;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    background: #fbfbfb;
    .return_content{
      width:100%;
      padding:16px 14px;
      box-sizing: border-box;
      background-color: #fff;
      margin-top:10px;
      position: relative;
      .item_box2{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top:16px;
        p:nth-child(1){
          font-size:14px;
          color:#999999;
          width:70px;
        }
        p:nth-child(2){
          font-size:14px;
          color:#999999;
        }
      }
      .returnDetail{
        display: flex;
        flex-direction: row;
        align-items: center;
        position: absolute;
        right:0;
        top:5px;
        padding:10px;
        p{
          font-size:12px;
          color:#9B9B9B;
        }
        img{
          width:4px;
          height:7px;
          margin-left:5px;
        }
      }
      .item_box2:nth-child(1){
        margin-top:0;
      }
    }
    .nav {
      width: 100%;
      height: 28px;
      margin-top:8px;
      .wrapper {
        white-space: nowrap;
        position: absolute;
        .item {
          display: inline-block;
          padding: 6px 0;
          margin-right: 24px;
          // border-bottom: 2px solid @base-color;
          font-size: 14px;
          color: #333333;
        }
        .router-link-active{
          border-bottom: 2px solid @base-color;
          color: @base-color;
          font-weight: 700;
        }
        // .active{
        //   border-bottom: 2px solid @base-color;
        //   color: @base-color;
        //   font-weight: 700;
        // }
        .item_active {
          border-bottom: 2px solid @base-color;
          color: @base-color;
        }
      }
    }
  }
  .view {
    padding-bottom: 70px;
  }
  .activeClass {
    margin-bottom: 70px;
  }
  .footBtn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 50px;
    background-color: #fff;
    z-index: 10;
    // transform: translateY(0);
    transition: all 0.2s ease-in-out;
    .wrapper {
      white-space: nowrap;
      position: absolute;
      .item {
        margin-top: 9px;
        display: inline-block;
        padding:0 14px;
        height: 30px;
        border: 1px solid @base-color;
        text-align: center;
        line-height: 30px;
        color: @base-color;
        margin-right: 20px;
        font-size: 14px;
        img {
          display: inline-block;
          height: 5px;
          width: 9px;
        }
      }
      .item:nth-child(1) {
        background-color: @base-color;
      }
    }
  }
  .foot_active{
    bottom: -50px!important;
  }
  .folingPop{
    padding: 30px 12px 0;

    >div{
      width: 100%;
      height: 100%;
      position: relative;

      >p{
        font-size: 15px;
        text-align: center;
        line-height: 40px;
      }

      .filingBtnBox{
        width: 100%;
        position: absolute;
        bottom: 10px;

        >span{
          padding: 0 5px;
          font-size: 15px;
          text-align: center;
          line-height: 40px;
        }

        .cancelFiling{
          float: left;
        }

        .sureFiling{
          float: right;
          color: #367ede;
        }
      }

      .filingBtnBox::after{
        content: '';
        display: block;
        clear: both;
      }
    }
  }
  .btns{
      width:100%;
      height:130px;
      background-color:#fff;
      position: fixed;
      left:0;
      bottom:-100%;
      z-index: 9;
      transition: all 0.5s ease-in-out;
      span{
        display: inline-block;
        padding:4px 16px;
        font-size:14px;
        color: #36b374;
        border-right: 2px solid @base-color;
        margin-top:14px;
      }
  }
  }

}
// .btn_active{
//   bottom: 0!important;
// }

</style>
